
import React from "react";
import { 
  Carousel, 
  CarouselContent, 
  CarouselItem, 
  CarouselNext, 
  CarouselPrevious 
} from "@/components/ui/carousel";
import FadeIn from "@/components/FadeIn";

// Video URLs for the carousel
const videos = [
  "https://cdn.prod.website-files.com/666bb68c80a39d1a43c135f1%2F667268211a9c869a6af5cca7_Lumineux%20Gif1-15-transcode.mp4",
  "https://cdn.prod.website-files.com/666bb68c80a39d1a43c135f1%2F667268a8dbac3e65387d4a5e_Kane%20Gif2-14-transcode.mp4",
  "https://cdn.prod.website-files.com/666bb68c80a39d1a43c135f1%2F667268ad10743628cc81baef_Kane%20Gif1-13-transcode.mp4",
  "https://cdn.prod.website-files.com/666bb68c80a39d1a43c135f1%2F667268b3218cf85f1c4770e6_Huppy%20Gif2-12-transcode.mp4",
  "https://cdn.prod.website-files.com/666bb68c80a39d1a43c135f1%2F667268b952eb30a892c597fd_Hexclad%20Gif2-11-transcode.mp4",
  "https://cdn.prod.website-files.com/666bb68c80a39d1a43c135f1%2F667268c1f98af825e3ac9d4e_Hexclad%20Gif1-10-transcode.mp4",
  "https://cdn.prod.website-files.com/666bb68c80a39d1a43c135f1%2F667268ca1f3d768fd2cbce1a_C4%20Gif2-9-transcode.mp4"
];

const VideoCarousel = () => {
  return (
    <section className="py-16 bg-muted/30 overflow-hidden">
      <div className="container">
        <FadeIn className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">See Our Content in Action</h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Authentic user-generated content that drives engagement and conversions
          </p>
        </FadeIn>
        
        <FadeIn delay={200}>
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent className="-ml-4">
              {videos.map((videoUrl, index) => (
                <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="mx-auto w-[560px] rounded-xl border shadow-sm overflow-hidden">
                    <div className="px-[150px]">
                      <div className="w-[260px] h-[440px] overflow-hidden">
                        <video 
                          className="w-full h-full object-cover"
                          autoPlay 
                          loop 
                          muted 
                          playsInline
                        >
                          <source src={videoUrl} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-center mt-8">
              <CarouselPrevious className="relative static -left-0 translate-y-0 mr-2" />
              <CarouselNext className="relative static -right-0 translate-y-0 ml-2" />
            </div>
          </Carousel>
        </FadeIn>
      </div>
    </section>
  );
};

export default VideoCarousel;
